import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
// import notificationSound from '../../assets/audio/Screaming_Goat.mp3';
import notificationSound from '../../assets/audio/Alert01.wav';

import liracrypt from '../../components/Liracrypt/liracrypt';
import ApiErrorComp from '../../components/ApiErrorComp/ApiErrorComp';

const SpeechAudio = ({
    extraData = {},
    auxFunctions = {},
    selectedLid = '',
}) => {
    const getData = () => {
        liracrypt.get(auxFunctions?.config?.api || '/linedash/tts', { lid: selectedLid, ...auxFunctions?.config?.params, ...extraData })

            .then(response => {
                if (response.data.data.length === 0) return;
                playAudio(response.data.data)
            }).catch(err => {
                ApiErrorComp(err);
                console.log(err)
            })
    }

    useEffect(() => {
        getData();
        let interval;
        if (auxFunctions?.config?.interval) {
            interval = setInterval(() => {
                getData();
            }, auxFunctions?.config?.interval);
        }
        return (() => {
            clearInterval(interval);
        })
    }, []);
    const playAudio = (data, index = 0) => {
        if (!data) return;
        const audio = new Audio(require(`../../assets/audio/${data[index].alert}`));
        audio.play();
        audio.addEventListener('ended', () => {
            textToSpeech(data, index);
        });
    }

    const textToSpeech = (data, index) => {
        const synth = window.speechSynthesis;
        const utterThis = new SpeechSynthesisUtterance(data[index].text);
        synth.speak(utterThis);
        utterThis.addEventListener('end', () => {
            if (index < data.length - 1) {
                playAudio(data, index + 1);
            }
        })
    }

    return (
        <></>
    );

}

export default SpeechAudio;